//
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
export var ResourceType;
(function (ResourceType) {
    ResourceType["asset"] = "Asset";
    ResourceType["font"] = "Font";
})(ResourceType || (ResourceType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class Resource {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.id = model.persistentId;
        this.idInVersion = model.id;
        this.url = model.url;
        this.originalName = (_a = model.originalName) !== null && _a !== void 0 ? _a : null;
        this.scope = model.scope;
        this.type = ResourceType.asset;
    }
}
